import { render, staticRenderFns } from "./CtaSiteIntegrationBlock.vue?vue&type=template&id=58b7ecfa&scoped=true&"
import script from "./CtaSiteIntegrationBlock.vue?vue&type=script&lang=js&"
export * from "./CtaSiteIntegrationBlock.vue?vue&type=script&lang=js&"
import style0 from "./CtaSiteIntegrationBlock.vue?vue&type=style&index=0&id=58b7ecfa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b7ecfa",
  null
  
)

export default component.exports